import { PizzaLocation } from '../types';

export const searchPizzaPlaces = async (location: google.maps.LatLngLiteral): Promise<PizzaLocation[]> => {
  if (!window.google?.maps?.places) {
    throw new Error('Google Maps not loaded. Please try again.');
  }

  return new Promise((resolve, reject) => {
    const mapDiv = document.createElement('div');
    const map = new google.maps.Map(mapDiv, { 
      center: location,
      zoom: 15
    });

    const service = new google.maps.places.PlacesService(map);
    
    const request: google.maps.places.PlaceSearchRequest = {
      location,
      type: 'restaurant',
      keyword: 'chinese restaurant',
      rankBy: google.maps.places.RankBy.DISTANCE
    };

    service.nearbySearch(request, async (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK && results) {
        const closestResults = results.slice(0, 5);
        
        const detailedPlaces = await Promise.all(
          closestResults
            .filter(place => place.geometry?.location)
            .map(place =>
              new Promise<PizzaLocation>((resolvePlace) => {
                if (!place.place_id) {
                  resolvePlace({
                    id: place.place_id || '',
                    name: place.name || 'Unknown',
                    latitude: place.geometry?.location?.lat() || 0,
                    longitude: place.geometry?.location?.lng() || 0,
                    address: place.vicinity || '',
                    phone: '',
                    rating: place.rating || 0,
                    website: ''
                  });
                  return;
                }

                service.getDetails(
                  {
                    placeId: place.place_id,
                    fields: ['name', 'formatted_address', 'formatted_phone_number', 'rating', 'website', 'geometry']
                  },
                  (placeDetails, detailStatus) => {
                    if (detailStatus === google.maps.places.PlacesServiceStatus.OK && placeDetails) {
                      resolvePlace({
                        id: place.place_id || '',
                        name: placeDetails.name || place.name || 'Unknown',
                        latitude: placeDetails.geometry?.location?.lat() || place.geometry?.location?.lat() || 0,
                        longitude: placeDetails.geometry?.location?.lng() || place.geometry?.location?.lng() || 0,
                        address: placeDetails.formatted_address || place.vicinity || '',
                        phone: placeDetails.formatted_phone_number || '',
                        rating: place.rating || 0,
                        website: placeDetails.website || ''
                      });
                    } else {
                      resolvePlace({
                        id: place.place_id || '',
                        name: place.name || 'Unknown',
                        latitude: place.geometry?.location?.lat() || 0,
                        longitude: place.geometry?.location?.lng() || 0,
                        address: place.vicinity || '',
                        phone: '',
                        rating: place.rating || 0,
                        website: ''
                      });
                    }
                  }
                );
              })
            )
        );

        resolve(detailedPlaces);
      } else {
        if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
          resolve([]);
        } else {
          reject(new Error('Failed to fetch Chinese restaurants. Please try again.'));
        }
      }
    });
  });
};